// extracted by mini-css-extract-plugin
export default {"carsBookmarkCounterWrapper":"carsBookmarkCounterWrapper_carsBookmarkCounterWrapper__H5kQM"};